<kendo-card class="tabCard">
  <kendo-card-header class="tabHeader" [title]="tab.label">{{ tab.label }}</kendo-card-header>
  <kendo-card-body>
    <div style="padding: 0px 10px;">
      <span>
        @if (showAddBtn) { <button kendoButton class="success btnAdd" title="Add" (click)="addBtnClick()">Add</button> }

        @for (btn of tab.tabOptions.buttons; track btn) {
        <button (click)="callToolbarBtnFunction(btn)" [ngClass]="btn.cssClass" class="customButton button" kendoButton>
          @if (btn.icon) { <fa-icon [icon]="btn.icon"></fa-icon> }
          {{ btn.text }}
        </button>
        }
      </span>
      <br />
      <table class="tabTable" id="{{tab.label}}_table" #tabTable>
        <thead>
          <tr>
            @for (column of tab.tabOptions.columns; track column.field) {
            <th [title]="column.title" [width]="column.size">
              {{ column.title }}
            </th>
            }
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @if (!tab.loaded) {
          <tr>
            <td [colSpan]="tab.tabOptions.columns.length + 1">
              <kendo-skeleton shape="rectangle" animation="pulse" height="50px"></kendo-skeleton>
            </td>
          </tr>
          } @else {
          @for (row of pagedData; track row) {
          <tr>
            @for (column of tab.tabOptions.columns; track column.field) {
            <td [style.width.px]="column.size" style="padding: 8px 14px">
              @if (tab.tabOptions.propertyNameToAddHyperlink && column.field == tab.tabOptions.propertyNameToAddHyperlink) {
              <a style="text-decoration:none;" [href]="row[tab.tabOptions.hyperlinkPropertyName ?? '']" [target]="linkTarget">{{ getConvertedItemValue(row[column.field], column.format) }}</a>
              } @else {
              <span>{{ getConvertedItemValue(row[column.field], column.format) }}</span>
              }
            </td>
            }
            <td>
              <!-- Actions -->
              @if (tab.tabOptions.showEditBtn) {
              <button class="editButton" (click)="editBtnClick(pagedData.indexOf(row))">
                <fa-icon [icon]="icoEdit"></fa-icon>
                {{ tab.tabOptions.editBtnTitle ?? "Edit" }}
              </button>
              }
              @if (tab.tabOptions.showDeleteBtn) {
              <button class="deleteButton" (click)="deleteBtnClick(pagedData.indexOf(row))">
                <fa-icon [icon]="icoDelete"></fa-icon>
                {{ tab.tabOptions.deleteBtnTitle ?? "Delete" }}
              </button>
              }
              @for (btn of tab.tabOptions.actions; track btn.text) {
              <button (click)="callCustomBtnFunction(btn, row)" [ngClass]="btn.cssClass" class="customButton">
                @if (btn.icon) { <fa-icon [icon]="btn.icon"></fa-icon> }
                {{ btn.text }}
              </button>
              }
            </td>
          </tr>
          }
          }
        </tbody>
      </table>
      @if (shouldPage) {
      <div class="pagingSection">
        <div class="pagingActions">
          @for (action of pagingActions; track action) {
          <button kendoButton class="actionBtn" (click)="page(action.index)">
            {{ action.text }}
          </button>
          }
        </div>
        <div class="pagingInfo">
          <span>{{ pageRange }} of {{ total }}</span>
        </div>
      </div>
      }
    </div>
  </kendo-card-body>
</kendo-card>
